import React, { Component } from 'react'
import '../styles/Confirmation.css'
import '../styles/Booking.css'
import '../styles/Navbar.css'
import '../styles/BookingContainer.css'
import { injectIntl, defineMessages } from "react-intl"
import { withRouter, Link } from 'react-router-dom'
import qs from 'qs'
import { API_ROOT } from '../api-config'
import axios from 'axios'
import { Cookies } from 'react-cookie-banner'

const voucherTypes = { reduc: "reduc", ancv: "ancv", passculture: "pass_culture" };

const bookingStyle = {
  position: "static",
  alignItems: "center"
}

const tinyHash = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16);
};

const buildAPI_URL = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idOrder}&token_order=${tokenOrder}`
}
const bank_URL = (idOrder, tokenOrder, uid) => {
  return `${API_ROOT}Axepta.php?action=pay&id_order=${idOrder}&token_order=${tokenOrder}&uid=${tinyHash(uid)}`
}

class Payment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      loading: true,
      orderId: null,
      percentage: 0,
      currentEur: 0,
      totalEur: 0,
      remainingTime: 0,
      remainingTimestamp: 0,
      remainingSeconds: 0,
      price: 0,
      pricePerPlayer: 0,
      multipaymentHours: 0,
      statuses: [],
      bookings: [],
      cartTotalOpened: false,
      totalOptions: 0,
      couponsList: [],
      couponCode: 0,
      multiPaymentFee: 0,
      orderId: null,
      orderToken: null,
      status: null
    }
  }

  checkOrderStatus = async () => {
    if (this.props.location.search) {
      const orderInfo = qs.parse(this.props.location.search.slice(1))
      this.setState({
        orderId: orderInfo.id_order,
        loading: false,
      })
      await this.getOrderInfo(orderInfo.id_order, orderInfo.token_order)
    }
  }

  getOrderInfo = async (id, token) => {
    const { intl: { formatMessage } } = this.props
    axios.get(buildAPI_URL(id, token))
      .then(response => {
       if (response.data.result) {
         let bookings = []
         let totalOptions = 0;
          response.data.rooms.forEach(reservation => {
            bookings.push(reservation);
            totalOptions += reservation.room_option_price_without_promo;
          });
         let couponsList = [];
         let voucherType = response.data.voucher_type === "pourcent"
         if (response.data.voucher_value) {
           const newCoupon = {
             voucherCode: response.data.voucher_used,
             voucherValue: parseFloat(response.data.voucher_value, 10).toFixed(2),
             voucherPercent: voucherType,
             voucherType: voucherTypes.reduc,
             voucherTitle: formatMessage(messages.voucher),
             voucherData: response.data
           }
           couponsList.push(newCoupon);
         }
         
          this.setState({
            email: response.data.email,
            price: response.data.price,
            pricePerPlayer: response.data.multipayment_amount_per_player,
            percentage: response.data.multipayment_perc,
            currentEur: response.data.multipayment_total,
            totalEur: response.data.price,
            remainingTime: response.data.multipayment_remaining_hours,
            remainingTimestamp: response.data.multipayment_remaining_ts,
            statuses: response.data.players_multipayment_status,
            multipaymentHours: response.data.multipayment_hours,
            loading: false,
            bookings: bookings,
            totalOptions: totalOptions,
            multiPaymentFee: response.data.multipayment_fee,
            couponsList: couponsList,
            couponCode: response.data.voucher_used,
            orderId: id,
            orderToken: token,
            status: response.data.status
          }, () => this.startCountdown())
          

          const cookies = new Cookies()
          cookies.set('orderDetails', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('bookings', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('bookingsTokens', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('orderDetailsVouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('vouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('cart_step', 0, { path: '/', expires: new Date('2040-12-17T03:24:00') });

          cookies.remove("orderDetails")
          cookies.remove("bookings")
          cookies.remove("bookingsTokens")
          cookies.remove("orderDetailsVouchers")
          cookies.remove("vouchers")
          cookies.remove("cart_step")
        } else {
          this.setState({ error: true, loading: false })
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  toggleCartTotalOpened = () => {
    this.setState({
      cartTotalOpened: !this.state.cartTotalOpened,
    });
  };

  startCountdown() {
    clearInterval(this._countdownInterval)
    this._countdownInterval = setInterval(() => {
      const nowSec = Math.floor(Date.now() / 1000)
      const diff = this.state.remainingTimestamp - nowSec
      this.setState({ remainingSeconds: diff > 0 ? diff : 0 })
    }, 1000)
  }

  formatHMS(totalSec) {
    const h = Math.floor(totalSec / 3600)
    const m = Math.floor((totalSec % 3600) / 60)
    const s = totalSec % 60
    const pad = (n) => n.toString().padStart(2, '0')
    return `${pad(h)}:${pad(m)}:${pad(s)}`
  }

  componentDidMount = async () =>  {
    if (this.props.location.search) {
      window.setTimeout(async () => {
        await this.checkOrderStatus()
      }, 1000)
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props;
    const voucherTypes = { reduc: "reduc", ancv: "ancv", passculture: "pass_culture" };
    const bookingCheckout = this.state.bookings.length > 0;
    const groupCoupons = () => {
      let val = [];
      let gr = {};
      this.state.couponsList.map((coupon, i) => {
        if (!gr[coupon.voucherType]) {
          gr[coupon.voucherType] = { title: coupon.voucherTitle, value: coupon.voucherValue ? parseFloat(coupon.voucherValue) : 0, percent: coupon.voucherPercent }
        } else {
          if (coupon.voucherValue) {
            gr[coupon.voucherType].value += parseFloat(coupon.voucherValue);
          }
        }
      });

      Object.keys(gr).forEach((key) => {
        val.push(<div className="cart-total-in-line"><div>{voucherTypes.reduc === key ? gr[key].title + " " + this.state.couponCode : gr[key].title} </div><div className="cart-total-in-line-voucher">-&nbsp;{Math.floor(gr[key].value)},{(Math.round((gr[key].value % 1) * 100) / 100).toFixed(2).split(".")[1] + (gr[key].percent ? " %" : " €")}</div></div>);
      });

      return val;
    };

    let bookings = [];
    let totalGames = 0;
    for (const booking of this.state.bookings) {
      const formattedDate = booking.reservation_date.split('-').reverse().join('/');
      const formattedHour = booking.time_begin.split(':').slice(0, 2).join('h');
      
      bookings.push({
        title: formatMessage(messages.bookingTitle, { ROOM_NAME: booking.room_name, DATE: formattedDate, HOUR: formattedHour, NB_PLAYERS: booking.quantity_player, LANG: (booking.lang == "fr" ? "Français" : "Anglais") }), 
        price: booking.price_reservation_total_without_promo });
      totalGames += booking.price_reservation_total_without_promo;
    }

    const howDoesItWorks5 = formatMessage(messages.howDoesItWorks5);
    return (
      <div className="payment">
      {this.state.loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <div className="navbar navbar-sticky navbar-booking navbar-cart navbar-payment" style={{ position: 'static', alignItems: 'center', paddingRight: "0!important" }}>
      <h1>{formatMessage(messages.title)}{this.state.orderId}</h1>
      </div>
      <div className="cart-container-display">
      <div className="cart-container-display-left">
      </div>
      {(this.state.status != "canceled" && this.state.status != "paid") ? 
      <div id="cart-summary" className="cart-summary cart-summary-payment">
        <div className="payment-header">
        <div>
          <div>
            <h2>{this.state.currentEur } €</h2>
          </div>
          <div>
            {formatMessage(messages.collectOn)} {this.state.totalEur} €
          </div>
        </div>
        <div>
          <div>
            <h2><svg width="20" height="20" viewBox="0 0 512 512">
            <path id="Ovale" fill="none" stroke="#555555" strokeWidth="50" d="M 487 256 C 487 128.422211 383.577789 25 256 25 C 128.422226 25 25 128.422211 25 256 C 25 383.577759 128.422226 487 256 487 C 383.577789 487 487 383.577759 487 256 Z" />
            <path id="Ligne" fill="none" stroke="#555555" strokeWidth="45" strokeLinecap="round" strokeLinejoin="round" d="M 256 256 L 256 102" />
            <path id="path1" fill="none" stroke="#555555" strokeWidth="45" strokeLinecap="round" strokeLinejoin="round" d="M 167 256 L 255 256" />
            </svg> {this.formatHMS(this.state.remainingSeconds)} </h2>
          </div>
          <div>
            {formatMessage(messages.remainingHours)}
          </div>
        </div>
        </div>

        <div className="progress-wrapper">
        <div className="progress-container">
          <div className="progress-bar" style={{ width: this.state.percentage + '%' }}>
          <div>{ this.state.percentage }%&nbsp;&nbsp;</div>
          </div>
        </div>
        </div>
        <div className="payment-warning">
          <div>
          <svg width="23" height="23" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path id="Rectangle-arrondi" fill="#65afea" fillRule="evenodd" stroke="#65afea" strokeWidth="45" strokeLinecap="round" strokeLinejoin="round" d="M 22 447 C 22 469.0914 39.908607 487 62 487 L 447 487 C 469.0914 487 487 469.0914 487 447 L 487 63 C 487 40.9086 469.0914 23 447 23 L 62 23 C 39.908607 23 22 40.9086 22 63 Z" />
            <path id="Ligne" fill="#65afea" fillRule="evenodd" stroke="#ffffff" strokeWidth="70" strokeLinecap="round" strokeLinejoin="round" d="M 255 400 L 256 219" />
            <path id="Ovale" fill="#65afea" fillRule="evenodd" stroke="#ffffff" strokeWidth="45" strokeLinecap="round" strokeLinejoin="round" d="M 265 122 C 265 116.477142 260.522858 112 255 112 C 249.477158 112 245 116.477142 245 122 C 245 127.522858 249.477158 132 255 132 C 260.522858 132 265 127.522858 265 122 Z" />
          </svg>
          </div>
          <div>
          {formatMessage(messages.payWarning)}
          </div>
        </div>

        <div className="payment-list">
          <div style={{ marginBottom: '30px' }}>
                  <h2>{formatMessage(messages.payerList)}</h2>
          </div>
          <div>
            {Object.entries(this.state.statuses).map(([email, status], index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              
                <div style={{ marginLeft: '10px' }}></div>
                {this.state.remainingTime > 0 ? 
                  (status ? (
                      <div className="payment-pay-btn payment-pay-btn-payed learn-more themes-cart-cta cart-button">
                        <div style={{ display: 'flex', cursor: 'unset' }}>
                          <div>
                          <svg width="15" height="15" viewBox="0 0 512 512">
                            <path id="Rectangle-arrondi" fill="#7cd185" fillRule="evenodd" stroke="#7cd185" strokeWidth="70" strokeLinecap="round" strokeLinejoin="round" d="M 31 435 C 31 457.0914 48.908607 475 71 475 L 440 475 C 462.0914 475 480 457.0914 480 435 L 480 78 C 480 55.9086 462.0914 38 440 38 L 71 38 C 48.908607 38 31 55.9086 31 78 Z" />
                            <path id="Ligne" fill="#ffffff" fillRule="evenodd" stroke="#ffffff" strokeWidth="70" strokeLinecap="round" strokeLinejoin="round" d="M 132.999771 242.000214 L 256.000977 390.999054" />
                            <path id="Ligne-copie" fill="#ffffff" fillRule="evenodd" stroke="#ffffff" strokeWidth="70" strokeLinecap="round" strokeLinejoin="round" d="M 438.997925 93.997192 L 268.000671 391.000397" />
                          </svg>
                          </div>
                          <div>{formatMessage(messages.btnPayed)}</div>
                        </div>
                    </div>
                  ) : (
                      <div className="payment-pay-btn payment-pay-btn-not-payed learn-more themes-cart-cta cart-button" onClick={() => window.open(bank_URL(this.state.orderId, this.state.orderToken, email), "_blank")}><span data-text="{formatMessage(messages.next)}">{formatMessage(messages.btnPay)} {this.state.pricePerPlayer} €</span></div>
                  ))
                  : "" }
              <div>{email}</div>
            </div>
            ))}
                  
          </div>
        </div>
              <div className="payment-howto booking-rectangle booking-rectangle-confirmation">
                <div
                  className="booking-rectangle-pattern booking-rectangle-pattern-confirmation">

                  <div className="confirmation-title-container payment-confirmation-title-container">
                    <h1 className="payment-howto-title">{formatMessage(messages.howDoesItWorksTitle)}</h1>
                    <ul className="payment-howto-content">
                      <li>{formatMessage(messages.howDoesItWorks1)}</li>
                      <li>{formatMessage(messages.howDoesItWorks2, { VAR: this.state.multipaymentHours })}</li>
                      <li>{formatMessage(messages.howDoesItWorks3)}</li>
                      <li>{formatMessage(messages.howDoesItWorks4)}</li>
                      <li dangerouslySetInnerHTML={{ __html: howDoesItWorks5 }}></li>
                    </ul>
                  </div>

                </div>
              </div>

            </div>
      : 
            (<div style={{ textAlign: "center", width: '100%' }} className="cart-total-top-line">
              {
                ((this.state.status == "canceled") ? 
                  (
                    <div>{formatMessage(messages.orderCanceled)}</div>
                  )
                  :
                  (
                    (this.state.status == "paid") ? 
                      <div>{formatMessage(messages.orderPayed)}</div>
                    : ""
                  )
                )
              }
      </div>)
      }


            

      <div className={"cart-total" + (this.state.cartTotalOpened ? " cart-total-opened cart-total-opened-animation" : "")} onClick={() => this.toggleCartTotalOpened()}>
        <div className="cart-total-top-line">
          {formatMessage(messages.summaryTitle)}
        </div>
        <div className="cart-total-top-line-mobile">
          <div><i className={"arrow " + (this.state.cartTotalOpened ? "down" : "up")}></i> {formatMessage(messages.totalCart)}</div>
              <div className="cart-total-top-line-main-price">{(this.state.cartTotalOpened ? (Math.floor(this.state.totalEur) + "," + (Math.round((this.state.totalEur % 1) * 100) / 100).toFixed(2).split(".")[1]) : (Math.floor(this.state.totalEur) + "," + (Math.round((this.state.totalEur % 1) * 100) / 100).toFixed(2).split(".")[1])) } €</div>
        </div>
        {
            <React.Fragment>
              <div className={this.state.cartTotalOpened ? "cart-displayed" : "cart-hidden"}>
                <div className="cart-total-break"></div>
                <div className="cart-total-line"></div>
                {
                
                bookings.map((booking, index) => (
                  <div key={index} className="cart-total-in-line">
                      <div>{booking.title}</div>
                  </div>
                ))
                }
                <div className={"cart-total-in-line" } style={{ fontWeight: 600 }}>
                    <div>{formatMessage(messages.games)} : </div><div>{Math.floor(totalGames)},{(Math.round((totalGames % 1) * 100) / 100).toFixed(2).split(".")[1]} €</div>
                </div>
                <div className={"cart-total-in-line" + (this.state.totalOptions > 0 ? "" : " hidden")}>
                  <div>{formatMessage(messages.options)} : </div><div>{Math.floor(this.state.totalOptions)},{(Math.round((this.state.totalOptions % 1) * 100) / 100).toFixed(2).split(".")[1]} €</div>
                </div>
                <div className={"cart-total-in-line" + (this.state.couponsList.length > 0 ? "" : " hidden")}>
                  <div>{formatMessage(messages.discount)} : </div>
                </div>
                {groupCoupons()}
                <div className="cart-total-line cart-total-line-last"></div>
                { this.state.multiPaymentFee > 0 ?
                <div className="cart-total-in-line">
                  <div> {formatMessage(messages.multiPaymentOption) } : </div><div>{this.state.multiPaymentFee} €</div>
                </div> : "" }
                <div className="cart-total-line cart-total-line-last"></div>
                <div className="cart-total-bottom-line">
                  <div>{formatMessage(messages.totalCart)} :</div>
                    <div className="cart-total-top-line-main-price">{(Math.floor(this.state.totalEur) + "," + (Math.round((this.state.totalEur % 1) * 100) / 100).toFixed(2).split(".")[1]) } €</div>
                </div>
              </div>
            </React.Fragment>
      }
      </div>
      <div class="cart-container-display-right"></div>
      </div>
      </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'payment.title',
    defaultMessage: 'Paiement partagé : commande n°'
  },
  collectOn: {
    id: 'payment.collectOn',
    defaultMessage: 'collecté sur'
  },
  remainingHours: {
    id: 'payment.remainingHours',
    defaultMessage: 'Temps restant'
  },
  payWarning: {
    id: 'payment.payWarning',
    defaultMessage: 'En cas de non paiement des autres débiteurs, le reste dû sera débité sur le compte de la personne qui a effectué la commande'
  },
  payerList: {
    id: 'payment.payerList',
    defaultMessage: 'Liste des payeurs'
  },
  btnPayed: {
    id: 'payment.btnPayed',
    defaultMessage: 'Payé'
  },
  btnPay: {
    id: 'payment.btnPay',
    defaultMessage: 'Payer la part de '
  },
  howDoesItWorksTitle: {
    id: 'payment.howDoesItWorksTitle',
    defaultMessage: 'Comment ça marche ?'
  },
  howDoesItWorks1: {
    id: 'payment.howDoesItWorks1',
    defaultMessage: 'Une commande a été effectuée en paiement partagé. Cliquez sur "Payer ma part" pour payer votre part.'
  },
  howDoesItWorks2: {
    id: 'payment.howDoesItWorks2',
    defaultMessage: 'Vous avez {VAR} heures pour payer votre part.'
  },
  howDoesItWorks3: {
    id: 'payment.howDoesItWorks3',
    defaultMessage: 'Le paiement s\'effectue uniquement par carte bancaire.'
  },
  howDoesItWorks4: {
    id: 'payment.howDoesItWorks4',
    defaultMessage: 'Si le délai est dépassé, le montant sera débité sur le compte bancaire de la personne qui a réalisé la commande.'
  },
  howDoesItWorks5: {
    id: 'payment.howDoesItWorks5',
    defaultMessage: 'En cas d’émission d’un avoir dans le cadre du respect des <a href=\"https://www.one-hour.fr/conditions-annulation/\">modalités d’annulation et de modification d’une session de jeu</a>, l’avoir sera envoyé seulement à la personne ayant initié la réservation.'
  },
  howDoesItWorks6: {
    id: 'payment.howDoesItWorks6',
    defaultMessage: 'Si vous utilisez un compte en débit immédiat, l’empreinte bancaire peut apparaître temporairement sur votre relevé, sans entraîner de débit réel.'
  },
  summaryTitle: {
    id: 'payment.summaryTitle',
    defaultMessage: "Récapitulatif de commande"
  },
  totalCart: {
    id: 'payment.totalCart',
    defaultMessage: "Montant total"
  },
  games: {
    id: 'payment.games',
    defaultMessage: "Parties"
  },
  giftCard: {
    id: 'payment.giftCard',
    defaultMessage: "Carte cadeaux"
  },
  options: {
    id: 'payment.options',
    defaultMessage: "Options"
  },
  discount: {
    id: 'payment.discount',
    defaultMessage: "Réductions"
  },
  multiPaymentOption: {
    id: 'payment.multiPaymentOption',
    defaultMessage: "Frais de paiement partagé"
  },
  voucher: {
    id: 'payment.voucher',
    defaultMessage: "Code Promo"
  },
  bookingTitle: {
    id: 'payment.bookingTitle',
    defaultMessage: "{ROOM_NAME} {DATE}, à {HOUR} / {NB_PLAYERS} joueurs / {LANG}"
  },
  orderCanceled: {
    id: 'payment.orderCanceled',
    defaultMessage: "La commande a été annulée"
  },
  orderPayed: {
    id: 'payment.orderPayed',
    defaultMessage: "La commande a été payée"
  }
})

export default withRouter(injectIntl(Payment))



// WEBPACK FOOTER //
// ./src/components/Payment.js